import ActionsBuilder from 'src/utils/actions/ActionsBuilder';

export const IDENTIFIER = '[MANAGE AWARDS]';

export const actions = ActionsBuilder.buildList(IDENTIFIER);

export default actions;
